import { reducer as homeReducer } from './home.slice';

export default homeReducer;
